import React, { MouseEvent, useState } from 'react';
import { Delete } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import InsideSaving from 'components/loading/InsideSaving';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { api } from 'services/api';
import { toast } from 'react-toastify';
import { Package } from 'types/package';

interface PackageItemModuleProps {
  pkg: Package;
  handleSearch: () => void;
}

const PackageItemModule: React.FC<PackageItemModuleProps> = ({ pkg, handleSearch }) => {
  const [deleting, setDeleting] = useState(false);

  function handleDelete(e: MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    setDeleting(true);

    api
      .delete(`/packages/${pkg.id}`)
      .then(() => {
        toast.success('Pacote excluido com sucesso');
        handleSearch();
      })
      .catch(() => {
        toast.error('Erro ao excluir pacote');
      })
      .finally(() => setDeleting(false));
  }

  return (
    <ModuleCard
      idLabel={`ID ${pkg.id}`}
      title={pkg.name}
      subtitle={pkg.formattedSupplierName || 'Pacote'}
      actions={
        <Tooltip title="Excluir pacote">
          <IconButton onClick={handleDelete} color="error" size="small">
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      }
      fields={[{ label: 'Fornecedor', value: pkg.formattedSupplierName, fullWidth: true }]}
      metrics={[
        { label: 'Custo', value: pkg.formattedCostPrice, tone: 'error' },
        { label: 'Venda min.', value: pkg.formattedSalePriceMin, tone: 'primary' },
        { label: 'Venda max.', value: pkg.formattedSalePriceMax, tone: 'success' },
      ]}
      onClick={() => history.push(`/packages/${pkg.id}`)}
    >
      {deleting && <InsideSaving />}
    </ModuleCard>
  );
};

export default PackageItemModule;
